import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { RiCloseFill } from '@remixicon/react';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect } from 'react';

type ModalProps = {
	id: string;
	open: boolean;
	onClose: () => void;
	children: React.ReactNode;
	outsideClick?: boolean;
	title?: string;
};

const ModalPick = ({
	open,
	onClose,
	children,
	id,
	outsideClick = false,
	title = '',
}: ModalProps) => {
	useEffect(() => {
		App.addListener('backButton', (event) => {
			if (open) {
				onClose();
			}
		});

		return () => document.body.classList.remove('overflow-hidden');
	}, [open]);

	return (
		<AnimatePresence>
			{open && (
				<motion.div
					className={
						'fixed inset-0 z-50 bg-white px-3.5 pt-10 shadow-lg ' +
						(Capacitor.getPlatform() === 'ios'
							? ' pt-safe-offset-10 '
							: ' ')
					}
					initial="hidden"
					animate="visible"
					exit="exit"
					variants={{
						hidden: { y: '100%', opacity: 0 },
						visible: { y: 0, opacity: 1 },
						exit: { y: '100%', opacity: 0 },
					}}
					transition={{
						type: 'spring',
						stiffness: 300,
						damping: 30,
					}}
				>
					<div className="flex flex-row justify-between items-center pb-4">
						<div className="self-stretch text-primary text-base font-bold font-bahnschrift">
							{title}
						</div>
						<button
							onClick={onClose}
							className="rounded-lg text-gray-400 bg-white hover:bg-gray-50 hover:text-gray-600 flex"
						>
							<RiCloseFill className="w-5 h-5" color="#717680" />
						</button>
					</div>

					{children}
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default ModalPick;
